import { Navigate, useParams } from 'react-router-dom'
import { financialAccountsBasePath } from './financialAccountsScope'

/**
 * Route element for a facility's retired Banking page
 * (`/settings/facilities/:facilityId/banking` and anything below it): sends
 * the user to the facility's Financial Accounts page. Plaid's OAuth callback
 * still navigates to the old path, and bookmarks hold it.
 */
export function LegacyFacilityBankingRedirect() {
  const { facilityId } = useParams<{ facilityId: string }>()
  return (
    <Navigate
      to={facilityId ? financialAccountsBasePath({ facilityId }) : '/settings/facilities'}
      replace
    />
  )
}
